export const INSIDER_SUPPORT_URL = "https://icpinsiderpartners.slack.com";

export const INSIDER_SUPPORT_INVITE_URL =
  "https://join.slack.com/t/icpinsiderpartners/shared_invite/zt-4a95o70o4-UTDh94qz1gaAgVkpw6Gymw";

export const INSIDER_SUPPORT_LABEL = "Insider Support";

export const INSIDER_SUPPORT_JOIN_LABEL = "Need access? Join here →";

export const INSIDER_PARTNER_TOOLTIP = "ICP Insider Partner";

export const INSIDER_GOLD = "#C9A227";

export const isPrioritySellerStatus = (value) =>
  value === 1 || value === "1" || value === true;

export const hasPrioritySellerAccess = (user = {}) =>
  user?.priority_seller === true || isPrioritySellerStatus(user?.priority_seller);
